export const DOMAIN = 'auth.customer.consentConfigs';
